var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.contentExtra)?_c('span',[_c('em',[_vm._v(_vm._s(_vm.contentExtra))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }